import React, {FC} from "react"

import {IconTypes} from "@irati/ui/src/Icon"
import adminTracking from "@irati-tracking/admin"
import {ANALYTICS_BASE} from "@irati-web/admin/src/routes/routeConfig"

import {RelativeDiv} from "../styled"
import AdminRouterLink from "./AdminRouterLink"

interface Props {
  isCollapsed: boolean
}

const ReportingAdminRouterLink: FC<Props> = ({isCollapsed}) => {
  return (
    <RelativeDiv>
      <AdminRouterLink
        id="reportingPageButton"
        isCollapsed={isCollapsed}
        to={ANALYTICS_BASE}
        icon={IconTypes.analytics}
        onClick={adminTracking.navigationClickReporting}
        title="platform.adminNavigation.primary.analytics"
      />
    </RelativeDiv>
  )
}

export default ReportingAdminRouterLink
